import { FiX, FiMapPin, FiPhone } from 'react-icons/fi';

const CITY_WORDS = /^(hyderabad|secunderabad|telangana|india)$/i;

export const extractArea = (addr) => {
    if (!addr || !addr.trim()) return 'No address on file';
    const parts = addr.split(',').map((s) => s.trim()).filter(Boolean);
    const cleaned = parts.filter((p) => !CITY_WORDS.test(p) && !/^\d{5,6}$/.test(p.replace(/\s/g, '')));
    return cleaned.length ? cleaned[cleaned.length - 1] : parts[parts.length - 1] || 'No address on file';
};

export default function DeliveryRouteModal({ deliveries, onClose }) {
    const byUser = {};
    const stops = [];
    deliveries.forEach((d) => {
        const key = d.user_id || d.member_name;
        if (!byUser[key]) {
            byUser[key] = { ...d, books: [] };
            stops.push(byUser[key]);
        }
        byUser[key].books.push(d.book_title);
    });
    const areas = {};
    stops.forEach((s) => {
        const a = extractArea(s.delivery_address);
        (areas[a] = areas[a] || []).push(s);
    });
    const sortedAreas = Object.entries(areas).sort((a, b) => b[1].length - a[1].length);
    let stopNo = 0;

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="delivery-route-modal" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between px-6 py-4 border-b">
                    <h2 className="text-lg font-bold text-gray-800">🛵 Today&apos;s delivery route <span className="text-sm font-normal text-gray-400">— {stops.length} stop{stops.length === 1 ? '' : 's'}, grouped by area</span></h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-700" data-testid="delivery-route-close"><FiX size={22} /></button>
                </div>
                <div className="p-6 space-y-5">
                    {sortedAreas.length === 0 && <p className="text-sm text-gray-400 italic">No deliveries going out today.</p>}
                    {sortedAreas.map(([area, areaStops], ai) => (
                        <div key={area} data-testid={`route-area-${ai}`}>
                            <div className="flex items-center gap-2 mb-2">
                                <FiMapPin className="text-purple-600" />
                                <span className="font-semibold text-gray-800">{area}</span>
                                <span className="text-xs font-bold bg-purple-100 text-purple-700 rounded-full px-2 py-0.5">{areaStops.length} stop{areaStops.length === 1 ? '' : 's'}</span>
                            </div>
                            <ul className="space-y-2">
                                {areaStops.map((s) => {
                                    stopNo += 1;
                                    return (
                                        <li key={s.hold_id} className="border border-gray-200 rounded-lg px-3 py-2.5 flex gap-3" data-testid={`route-stop-${s.hold_id}`}>
                                            <span className="shrink-0 w-6 h-6 rounded-full bg-purple-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">{stopNo}</span>
                                            <div className="min-w-0 text-sm">
                                                <div className="font-medium text-gray-800">
                                                    {s.member_name}
                                                    {s.phone && (
                                                        <a href={`tel:${s.phone}`} className="ml-2 text-purple-600 text-xs inline-flex items-center gap-1"><FiPhone size={11} />{s.phone}</a>
                                                    )}
                                                </div>
                                                <div className="text-xs text-gray-500">{s.delivery_address || 'No address on file'}</div>
                                                <div className="text-xs text-gray-600 mt-1">📚 {s.books.join(' • ')}</div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
